import { connector } from "utils/common/connector";

const controller = "referrals";

// ---------------------------------------------
// GET REFERRAL BY CLIENT
// ---------------------------------------------
export const getReferralByClientService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getReferralByClient",
      params,
    );

    reply = {
      referrals: response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      referrals: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET ALL REFERRALS
// ---------------------------------------------
export const getAllReferralsService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getAllReferrals", params);

    reply = {
      referrals: response?.referrals ?? response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      referrals: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE OR UPDATE REFERRAL
// ---------------------------------------------
export const saveReferralService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "saveReferral", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};
